import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LocalStorageService } from 'ngx-webstorage';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-forget-password-message-alert',
  templateUrl: './forget-password-message-alert.component.html',
  styleUrls: ['./forget-password-message-alert.component.scss']
})

export class ForgetPasswordMessageAlertComponent implements OnInit {
  
  closeBtnName: string; 
  customerBtnName: string;

  @Input() data: any=[];  
  description: any[];
  forget_message_title: any;
  forget_message_block1: any;
  forget_message_block2: any;
  forget_message_block3: any;

  constructor(
    public navigation: NavigationService,
    private storage: LocalStorageService,
    public bsModalRef: BsModalRef,
    private translateService: TranslateService,
    private router: Router) {
   
  }
 
  ngOnInit() {
   
    var title = '';   
    this.description = [];
   
    this.closeBtnName = this.translateService.instant('ok');
    this.customerBtnName = this.translateService.instant('customer_service');
    
    if (this.data.db_qFailCount == 1) {
      this.forget_message_title= this.translateService.instant('forget_message_title');
      
      title = this.translateService.instant('forget_message_des');
      title = title.replace("@time", "2");
      this.description = title.split('\n');
    }
    if (this.data.db_qFailCount == 2) {
      this.forget_message_title = this.translateService.instant('forget_message_title');
      
      title = this.translateService.instant('forget_message_des');
      title = title.replace("@time", "1");
      this.description = title.split('\n');
    }
    if (this.data.db_qFailCount == this.data.specific_qFailCount) {
      this.forget_message_block1 = this.translateService.instant('forget_message_block1');
      this.forget_message_block2 = this.translateService.instant('forget_message_block2');
      this.forget_message_block3 = this.translateService.instant('forget_message_block3');
    }
   
  }

  goWallet() {
    this.bsModalRef.hide();
  }

  goHome() {

    var fromBtnClicked = this.storage.retrieve('fromBtnClicked');
    if (fromBtnClicked) {
      this.navigation.goBack();
      this.navigation.goBack();
      this.navigation.goBack();  
    } else {
      // this.navigation.goBack();
      // this.navigation.goBack();
      // this.navigation.goBack();  
      // this.navigation.goBack();
     ///auth/forget-password
     this.router.navigate(['/auth/forget-password'],{replaceUrl: true});
    }
   
    this.bsModalRef.hide();
  }

  goCustomerService() {
  
    var fromBtnClicked = this.storage.retrieve('fromBtnClicked');
    if (fromBtnClicked) {
      sessionStorage.setItem("rootUrl", "click-service-phone");
      this.storage.clear('fromBtnClicked');
    } else {
      sessionStorage.setItem("rootUrl", "service-phone"); 
    }

    this.navigation.goBack(); 
    this.bsModalRef.hide(); 
  }
  

}